import React from 'react';
import { I18n } from 'react-redux-i18n';
import Toggle from './../../../../common/Toggle';
import {
  changeColumnComparingCheckup,
  fetchLookupItem,
  REDUCER_NAME,
} from '../../reducer';
import { compose } from 'redux';
import { withComponentId } from '../../../../common/ComponentIdContext';
import { connect } from 'react-redux';
import { removeSpecialChar } from '../../../../helpers/Common';
import ScrollComponent from '../../../../common/ScrollComponent';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../../app/commonReducer';

const MAX_HEIGHT = 140;
const MAX_ITEM = 100;

class THeadDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textSearch: '',
    };
  }

  getOrganizations = () => {
    const { textSearch } = this.state;
    const { organizations, isBanking, currentDisplayCode } = this.props;
    const pattern = new RegExp(`^${removeSpecialChar(textSearch)}`, 'i');
    const newOrganizations = organizations.filter(item => {
      if (item.ticker === currentDisplayCode || item.isBanking !== isBanking) {
        return false;
      }

      return (
        pattern.test(item.ticker) ||
        pattern.test(removeSpecialChar(item.organShortName))
      );
    });

    return newOrganizations.splice(0, MAX_ITEM);
  };

  filterColumn = e => {
    const textSearch = e.target.value;

    this.setState({
      textSearch,
    });
  };

  initialState = () => {
    const { listLookupItems } = this.props;

    this.setState({
      textSearch: '',
      listLookupItems,
    });
  };

  handleButtonToggle = toggle => () => {
    this.initialState();
    toggle();
  };

  renderAction = toggle => {
    return (
      <button
        className="dropdown-toggle"
        type="button"
        aria-haspopup="true"
        onClick={this.handleButtonToggle(toggle)}
        aria-expanded="false"
      >
        <i className="icon-caret fs-11 ml-2" />
      </button>
    );
  };

  changeColumnComparing = (showHide, ticker) => () => {
    const { keyItem, componentId, fetchLookupItem } = this.props;
    fetchLookupItem(keyItem, ticker, componentId);
    showHide(false);
  };

  onInputKeyDown = (e, isShow, showHide) => {
    if (e.key === 'Enter' && isShow) {
      const organizations = this.getOrganizations();
      if (!organizations[0]) {
        return;
      }
      this.changeColumnComparing(showHide, organizations[0])();
    }
  };

  renderSearch = (isShow, showHide) => {
    const { textSearch } = this.state;

    return (
      <div className="search-box mt-5">
        <input
          className="search-input"
          value={textSearch}
          onKeyDown={e => this.onInputKeyDown(e, isShow, showHide)}
          type="search"
          onChange={this.filterColumn}
          placeholder={I18n.t('common.searchAdd.search')}
        />
        <button type="submit">
          <i className="icon-search" />
        </button>
      </div>
    );
  };

  renderListSearch = showHide => {
    const organizations = this.getOrganizations();

    return (
      <ScrollComponent appendStyle={{ maxHeight: MAX_HEIGHT }}>
        <div className="list-check px-10">
          {organizations.length > 0 ? (
            organizations.map(ticker => {
              return (
                <div
                  className="fa-checkup-th-search"
                  key={ticker.ticker}
                  onClick={this.changeColumnComparing(showHide, ticker)}
                >
                  <label className="text-item-title text-item-title2 checkbox">
                    {ticker.ticker}
                  </label>
                  <span
                    className="text-item-content text-truncate"
                    title={ticker.organShortName}
                  >
                    {ticker.organShortName}
                  </span>
                </div>
              );
            })
          ) : (
            <label className="text-no-data">{I18n.t('common.NO_DATA')}</label>
          )}
        </div>
      </ScrollComponent>
    );
  };

  renderPopup = (showHide, isShow) => {
    return (
      isShow && (
        <div
          className="dropdown-menu dropdown-menu-right drop-th drop-mecus show"
          aria-labelledby="dropdownMenuButton"
          style={{
            position: 'absolute',
            willChange: 'transform',
            top: '0px',
            left: '0px',
            transform: 'translate3d(-200px, 33px, 10px)',
          }}
        >
          {this.renderSearch(isShow, showHide)}
          {this.renderListSearch(showHide)}
        </div>
      )
    );
  };

  render() {
    return (
      <Toggle
        appendClassName={['d-inline-block']}
        renderAction={this.renderAction}
        renderPopup={this.renderPopup}
      />
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    listDataCheckup:
      state[REDUCER_NAME].listMultiComponent[componentId].faCheckupData
        .listDataCheckup,
    listLookupItems:
      state[REDUCER_NAME].listMultiComponent[componentId].faCheckupData
        .listLookupItems,
    yearReport:
      state[REDUCER_NAME].listMultiComponent[componentId].faCheckupData
        .yearReport,
    isBanking:
      state[REDUCER_NAME].listMultiComponent[componentId].searchParams
        .isBanking,
    currentDisplayCode:
      state[REDUCER_NAME].listMultiComponent[componentId].searchParams
        .displayCode,
    organizations: state[COMMON_REDUCER_NAME].listOrganizationSearch,
  };
};

const mapDispatchToProps = { changeColumnComparingCheckup, fetchLookupItem };

THeadDropDown.propTypes = {};

THeadDropDown.defaultProps = {
  listDataCheckup: {},
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(THeadDropDown);
